import React from 'react';
import PropTypes from 'prop-types';

// Presentational Component
const SearchTerm = ({ searchTerm, onSearch }) => {

	return (
		<input type="text"
			name="search"
			placeholder="Search"
			autoComplete="off"
			value={searchTerm}
			onChange={e => onSearch(e.target.value)} />
	);
};

SearchTerm.propTypes = {
	searchTerm: PropTypes.string,
	onSearch: PropTypes.func.isRequired
};

export default SearchTerm;



// WEBPACK FOOTER //
// ./src/components/search/SearchTerm.js